<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <HeaderButtons :pageTitle="'ショッピングカート'" :isShowCartButton="false" />
    </div>
    <div id="page-content" class="page-content">
      <ProductListTable />
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
              お買い物を続ける
            </button>
          </router-link>
        </div>
        <div class="page-footer__next-button-inner">
          <router-link
            v-bind:disabled="!isSubmit"
            to="/application-form"
            custom
            v-slot="{ navigate }"
          >
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              注文情報入力画面へ進む
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderButtons from 'vues/shopping-order/components/parts/HeaderButtons';
import ProductListTable from 'vues/shopping-order/components/parts/ProductListTable';

export default {
  components: {
    HeaderButtons,
    ProductListTable,
  },
  computed: {
    /**
     * カート商品を取得する
     */
    cartItems: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/cartItems'];
      },
    },
    /**
     * 合計額を取得する
     */
    totalPriceWithTax: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/totalPriceWithTax'];
      },
    },
    /**
     * 次の画面に遷移可能かを判定する
     */
    isSubmit: function () {
      if (!this.cartItems) return false;
      return this.cartItems.length > 0 && this.totalPriceWithTax < 1000000;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/debug.scss';
@import 'stylesheets/page.scss';
</style>
